import React, { useState } from 'react';
import TabNavigation from '../components/TabNavigation';
import MasonryGallery from '../components/MasonryGallery';
import VideoGrid from '../components/VideoGrid';
import Lightbox from '../components/Lightbox';

const Gallery = () => {
  const [activeTab, setActiveTab] = useState('portfolio');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentGallery, setCurrentGallery] = useState([]);

  const portfolioImages = [
    { id: 'portfolio-1', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/z21tbx9x_Honey%20Sofia%20-%200288-Edit-face%20blur%20%281%29.jpg' },
    { id: 'portfolio-2', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/wxxiaj3k_Honey%20Sofia%20-%201298-Edit-face%20blur.jpg' },
    { id: 'portfolio-3', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/h39u0qsh_Honey%20Sofia%20-%201387-Edit-face%20blur.jpg' },
    { id: 'portfolio-4', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/qdvybtie_Honey%20Sofia%20-%200660-Edit-skin%20smoothing.jpg' },
    { id: 'portfolio-5', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/z730fvdr_Honey%20Sofia%20-%201644-Edit-face%20blur.jpg' },
    { id: 'portfolio-6', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/1g0ga4pa_05_honeysofia%281%29.jpg' },
    { id: 'portfolio-7', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/aed5noou_Honey_0021-Edit-Edit.jpg' },
    { id: 'portfolio-8', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/hpnpk5oy_06_honeysofia_censored%281%29.jpg' },
    { id: 'portfolio-9', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/bc1wkman_Honey_0069-Edit-Edit.jpg' },
    { id: 'portfolio-10', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/7e4ktww2_Honey_0172-Edit.jpg' }
  ];

  const selfieImages = [
    { id: 'selfie-1', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/dp3jgxy0_IMG_20260403_080105_617.webp' },
    { id: 'selfie-2', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/7igl8g1m_image000000%20%287%29.jpg' },
    { id: 'selfie-3', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/ucq4vweq_image000000%20%283%29.jpg' },
    { id: 'selfie-4', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/bnprurq1_image000000%20%282%29.jpg' },
    { id: 'selfie-5', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/08kuy7v9_Point%20Blur_Mar242026_185947.jpg' },
    { id: 'selfie-6', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/0aifnia9_PXL_20240424_025556360.jpg' },
    { id: 'selfie-7', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/aqlxupdp_2025-12-28%2015_27_10.526%2B1100.jpg' },
    { id: 'selfie-8', url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/d65ldytx_2025-12-28%2015_27_48.878%2B1100.jpg' }
  ];

  const videos = [
    {
      id: 'video-1',
      url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/zbr1be4c_Video%20Project.mp4',
      title: 'Video 1'
    },
    {
      id: 'video-2',
      url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/vg3js2mc_v7.mp4',
      title: 'Video 2'
    },
    {
      id: 'video-3',
      url: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/2a5f074u_White.mp4',
      title: 'Video 3'
    }
  ];

  const tabs = [
    { id: 'portfolio', label: 'Portfolio' },
    { id: 'selfies', label: 'Selfies' },
    { id: 'videos', label: 'Videos' }
  ];

  const openLightbox = React.useCallback((index, gallery) => {
    setCurrentImageIndex(index);
    setCurrentGallery(gallery);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeLightbox = React.useCallback(() => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  }, []);

  const goToNext = React.useCallback(() => {
    setCurrentImageIndex((prev) => (prev + 1) % currentGallery.length);
  }, [currentGallery.length]);

  const goToPrevious = React.useCallback(() => {
    setCurrentImageIndex((prev) => (prev - 1 + currentGallery.length) % currentGallery.length);
  }, [currentGallery.length]);

  const handleKeyDown = React.useCallback((e) => {
    if (!lightboxOpen) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') goToNext();
    if (e.key === 'ArrowLeft') goToPrevious();
  }, [lightboxOpen, closeLightbox, goToNext, goToPrevious]);

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div>
      {/* Page Header */}
      <section className="section-padding" style={{ paddingBottom: '40px' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '16px' }}>
              Gallery
            </h1>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-secondary)' }}>
              A curated collection of moments, captured with intention.
            </p>
          </div>
        </div>
      </section>

      {/* Tab Navigation */}
      <section style={{ padding: '0 40px 40px' }}>
        <div className="container">
          <TabNavigation 
            tabs={tabs} 
            activeTab={activeTab} 
            onTabSelect={setActiveTab} 
          />
        </div>
      </section>

      {/* Content Area */}
      <section style={{ padding: '0 40px 120px' }}>
        <div className="container">
          {activeTab === 'portfolio' && (
            <MasonryGallery images={portfolioImages} onImageClick={openLightbox} />
          )}

          {activeTab === 'selfies' && (
            <MasonryGallery images={selfieImages} onImageClick={openLightbox} />
          )}

          {activeTab === 'videos' && (
            <VideoGrid videos={videos} />
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      <Lightbox
        isOpen={lightboxOpen}
        currentImage={currentGallery[currentImageIndex]?.url}
        currentIndex={currentImageIndex}
        totalImages={currentGallery.length}
        onClose={closeLightbox}
        onNext={goToNext}
        onPrevious={goToPrevious}
      />
    </div>
  );
};

export default Gallery;
